import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { formatPrice } from '../../../common/utils/formatters';

const TotalInfo = ({ labelsStore, cartStore, optionsStore, extraClass = '' }) => {
  const shouldRenderPrice = !!cartStore.subtotal && !!optionsStore.currency && !!optionsStore.isPriceEnabledOnSite;
  return (
    <>
      <div className={`cart-export__title total-quantity indent-words ${extraClass}`}>
        <span>{labelsStore.totalItems}</span>
        <span className="total-quantity__value">{cartStore.totalQuantity}</span>
      </div>

      {shouldRenderPrice && (
        <div className={`total-price indent-words ${extraClass}`}>
          <span>{formatPrice(cartStore.subtotal, optionsStore.locale)}</span>
          <span className="total-price__value">{optionsStore.currency}</span>
        </div>
      )}
    </>
  );
};

TotalInfo.propTypes = {
  extraClass: propTypes.string,

  labelsStore: propTypes.shape({
    totalItems: propTypes.string.isRequired
  }).isRequired,

  cartStore: propTypes.shape({
    subtotal: propTypes.number,
    totalQuantity: propTypes.number
  }).isRequired,

  optionsStore: propTypes.shape({
    isPriceEnabledOnSite: propTypes.bool.isRequired,
    currency: propTypes.string,
    locale: propTypes.string
  }).isRequired
};

TotalInfo.defaultProps = {
  extraClass: ''
};

export default inject((allStores) => ({
  labelsStore: allStores.labelsStore,
  cartStore: allStores.cartStore,
  optionsStore: allStores.optionsStore
}))(observer(TotalInfo));
